import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
import focusElement from '~/helpers/a11y-helpers';
export default {
  name: 'SkipTo',
  props: {
    text: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    tabindex: {
      type: [Number, null],
      default: null
    }
  },
  methods: {
    skipPressed: function skipPressed() {
      focusElement(this.$el.hash);
    }
  }
};